// Copyright ©️ 2026 eVolve MEP, LLC

import React from 'react';

import { type MachineElement, type WorkOrderPaginated, useEvolvePost } from '@evolvemep/api-ts';
import { Text } from '@mantine/core';

import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';
import { hasLengthExactly } from 'helpers/helper-types';

type Props = {
  elementsToRemove: MachineElement[];
  workOrder: WorkOrderPaginated;
  onElementsRemoved: () => void;
  onClose: () => void;
};

export const RemoveElementsModal = ({ elementsToRemove, workOrder, onElementsRemoved, onClose }: Props) => {
  const { apiCall: removeElementsApiCall } = useEvolvePost(`shop/workOrder/${workOrder.workOrderId}/removeElements`);

  return (
    <WrappedModal
      title={`Remove element${elementsToRemove.length === 1 ? '' : 's'} from work order`}
      opened={elementsToRemove.length > 0}
      onClose={onClose}
      onConfirm={async () => {
        await removeElementsApiCall({
          elementIds: elementsToRemove.map((e) => e.elementId),
        });
        onElementsRemoved();
      }}
      confirmationText="Remove from work order"
    >
      <Text>
        Are you sure you want to remove{' '}
        <b>
          {hasLengthExactly(elementsToRemove, 1) ? elementsToRemove[0].name : `${elementsToRemove.length} elements`}
        </b>{' '}
        from <b>{workOrder.name}</b>?
      </Text>
    </WrappedModal>
  );
};
